import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Observable, fromEvent, throttleTime } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class ResizeService {
    constructor(@Inject(PLATFORM_ID) private platform) {}
    getResizeEvent(): Observable<Event> {
        if(isPlatformBrowser(this.platform)) {
            return fromEvent(window, "resize").pipe(
                throttleTime(100) // Throttles the events to fire not more often than every 100ms
            );
        }
    }
}
